export interface IRepresentedBy {
    representedById: number;
    role: string;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IRepresentedBy = {
    getDefault(): IRepresentedBy {
      return {
        representedById: 0,
        role: ''
      };
    },
  };

  export interface IRepresentedByRes {
      records: IRepresentedBy[];
      totalRecordCount: number;
  }